export default "__VITE_ASSET__CxBnGfrc__"